class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          	// Init drag with polling + touch support
          	var self = this;
          	var dragInited = false;
          	var initDrag = function() {
          		if (dragInited) return;
          		// Find ANY scrollable element
          		var candidates = [
          			self.querySelector('.css-slider-holder'),
          			self.querySelector('.css-slider-viewport'),
          			self.querySelector('css-slider')
          		];
          		var scrollEl = null;
          		for (var i = 0; i < candidates.length; i++) {
          			if (candidates[i] && candidates[i].scrollWidth > candidates[i].clientWidth) {
          				scrollEl = candidates[i]; break;
          			}
          		}
          		if (!scrollEl) {
          			// Force the first candidate to be scrollable
          			for (var j = 0; j < candidates.length; j++) {
          				if (candidates[j]) {
          					candidates[j].style.overflowX = 'auto';
          					candidates[j].style.scrollBehavior = 'auto';
          					candidates[j].style.scrollSnapType = 'none';
          					scrollEl = candidates[j]; break;
          				}
          			}
          		}
          		if (!scrollEl) return;
          		dragInited = true;
          		var isDown = false, dragged = false, startX, sl, velX = 0, lastX = 0, lastT = 0, mid = 0;
          		scrollEl.style.cursor = 'grab';
          		scrollEl.style.webkitUserSelect = 'none';
          		scrollEl.style.userSelect = 'none';
          		scrollEl.style.scrollBehavior = 'auto';
          		scrollEl.style.scrollSnapType = 'none';
          		scrollEl.addEventListener('mousedown', function(e) {
          			cancelAnimationFrame(mid);
          			isDown = true; dragged = false; velX = 0;
          			scrollEl.style.cursor = 'grabbing';
          			startX = e.pageX; sl = scrollEl.scrollLeft;
          			lastX = e.pageX; lastT = Date.now();
          			e.preventDefault();
          		});
          		var snapCenter = function() {
          			var cards = scrollEl.querySelectorAll('.css-slide');
          			if (!cards.length) return;
          			var scrollRect = scrollEl.getBoundingClientRect();
          			var centerX = scrollRect.left + scrollRect.width / 2;
          			var best = 0, bestDist = Infinity;
          			for (var k = 0; k < cards.length; k++) {
          				var cardRect = cards[k].getBoundingClientRect();
          				var cardCenter = cardRect.left + cardRect.width / 2;
          				var d = Math.abs(cardCenter - centerX);
          				if (d < bestDist) { bestDist = d; best = k; }
          			}
          			var cardRect = cards[best].getBoundingClientRect();
          			var offset = (cardRect.left + cardRect.width / 2) - centerX;
          			var target = scrollEl.scrollLeft + offset;
          			scrollEl.style.scrollBehavior = 'smooth';
          			scrollEl.scrollLeft = Math.max(0, Math.min(target, scrollEl.scrollWidth - scrollEl.offsetWidth));
          			setTimeout(function() { scrollEl.style.scrollBehavior = 'auto'; }, 500);
          		};
          		var stopDrag = function() {
          			if (!isDown) return;
          			isDown = false; scrollEl.style.cursor = 'grab';
          			if (dragged && Math.abs(velX) > 0.5) {
          				var decel = function() {
          					velX *= 0.93;
          					scrollEl.scrollLeft -= velX;
          					if (Math.abs(velX) > 0.3) {
          						mid = requestAnimationFrame(decel);
          					} else {
          						snapCenter();
          					}
          				};
          				mid = requestAnimationFrame(decel);
          			} else if (dragged) {
          				snapCenter();
          			}
          		};
          		document.addEventListener('mouseup', stopDrag);
          		document.addEventListener('mousemove', function(e) {
          			if (!isDown) return;
          			e.preventDefault(); dragged = true;
          			scrollEl.scrollLeft = sl - (e.pageX - startX);
          			var now = Date.now();
          			var dt = now - lastT;
          			if (dt > 0) velX = (e.pageX - lastX) / dt * 16;
          			lastX = e.pageX; lastT = now;
          		});
          		scrollEl.addEventListener('click', function(e) {
          			if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
          		}, true);
          		// Disable snap on touch for smooth mobile drag
          		scrollEl.addEventListener('touchstart', function() {
          			scrollEl.style.scrollSnapType = 'none';
          			scrollEl.style.scrollBehavior = 'auto';
          		}, {passive: true});
          		scrollEl.addEventListener('touchend', function() {
          			setTimeout(function() { scrollEl.style.scrollSnapType = 'none'; }, 100);
          		}, {passive: true});
          	};
          	// Poll multiple times
          	setTimeout(initDrag, 500);
          	setTimeout(initDrag, 1500);
          	setTimeout(initDrag, 3000);
          	setTimeout(initDrag, 5000);
          }
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);